module.exports = __webpack_public_path__ + "img/Mockup_2_small.9c760919.jpg";